import { request } from "@/lib/api"
import { z } from "zod"

// As consultas de margem vêm do townhall, e não do baas-broker: é lá que moram as autorizações, e
// são elas que carregam a base da margem. O leilão sabe quanto sobrou para cada pessoa, mas não
// sobre quanto — sem a base, "quanto da margem legal está tomada" não tem como ser calculado.
//
// `usage` chega como texto, e não como enum fechado: uma faixa nova no serviço não pode derrubar a
// seção inteira por falha de schema. A tela desenha as faixas que conhece e ignora o resto.
export const MargemSchema = z.object({
    employer: z.object({ cnpj: z.string(), cnpj_root: z.string() }),
    people: z.object({
        authorized: z.number(),
        eligible: z.number(),
        ineligible: z.number(),
        failed: z.number(),
        in_progress: z.number(),
    }),
    ineligibility: z.array(z.object({ reason: z.string(), people: z.number() })),
    margin: z.object({
        people_with_data: z.number(),
        legal_margin_total: z.number(),
        available_total: z.number(),
        committed_total: z.number(),
        committed_share: z.number().nullish(),
        debt_total: z.number(),
        debt_to_base: z.number().nullish(),
        usage: z.array(z.object({ usage: z.string(), people: z.number() })),
    }),
    by_month: z.array(z.object({ month: z.string(), people: z.number() })),
})
export type Margem = z.infer<typeof MargemSchema>

export const fetchMargem = async (): Promise<Margem> =>
    request("/townhall/employer/insights", MargemSchema)
